<template>
  <div v-if="!loading">
    <form>
      <v-card class="my-5">
        <v-card-title>{{ form.name }}  - Predvolení spracovatelia pre IAPSZ</v-card-title>
        <v-card-text>
          <v-list>
            <v-list-item
              v-for="(input, index1) in form.spracovatelia"
              :key="input.id"
            >
              <v-row dense>
                <v-col>
                  <v-autocomplete
                    v-model="input.user"
                    item-text="string_details"
                    item-value="id"
                    placeholder="Používateľ"
                    label="Používateľ"
                    :items="items_administrator[index1]"
                    auto-select-first
                    :search-input.sync="search_administrator[index1]"
                    cache-items
                    :loading="loading_administrator[index1]"
                    hide-no-data
                    append-icon="mdi-delete"
                    @click:append="deleteRowSpracovatel(index1)"
                  />
                </v-col>
                <v-col cols="2">
                  <v-select
                    v-model="input.type"
                    :items="select_administrator"
                    label="Typ"
                  />
                </v-col>
              </v-row>
            </v-list-item>
          </v-list>

          <v-btn
            text
            icon
            color="secondary"
            @click="addRow()"
          >
            <v-icon>mdi-plus</v-icon>
          </v-btn>
        </v-card-text>
      </v-card>

      <v-layout
        v-if="!form.closed"
        pt-5
      >
        <v-btn
          dark
          color="primary"
          @click="updateItem()"
        >
          Uložiť
        </v-btn>
        <div class="flex-grow-1" />
      </v-layout>
    </form>

    <v-snackbar
      v-model="snackbar_saved"
      color="success"
      :timeout="3000"
    >
      Uložené
      <v-btn
        text
        @click="snackbar_saved = false"
      >
        Zavrieť
      </v-btn>
    </v-snackbar>
    <v-snackbar
      v-model="snackbar_error"
      color="error"
      :timeout="5000"
    >
      Chyba
    </v-snackbar>
  </div>

  <div v-else>
    <form-skeleton-component skeleton_type="Spracovatelia" />
  </div>
</template>

<script>
import { APIService } from "@/http/APIService.js";
import FormSkeleton from "@/views/iapsz/components/FormSkeleton.vue";

const apiService = new APIService();

export default {

  components: {
    "form-skeleton-component": FormSkeleton,
  },

  data: () => ({
    loading: false,
    snackbar_saved: false,
    snackbar_error: false,
    dialog: false,

    loading_administrator: [],
    search_administrator: [],
    watchers: [],

    form: {
      id: null,
      spracovatelia: []
    },
    items_administrator: [],
    select_administrator: [
      { value: "Administrátor", text: "Administrátor" },
      { value: "Spracovateľ", text: "Spracovateľ" },
      { value: "Externý spracovateľ", text: "Externý spracovateľ" },
    ],
  }),

  watch: {},

  created() {
    this.getItem();
  },

  methods: {
    updateWatchersAnd() {
      for (let i = 0; i < this.form.spracovatelia.length; i++) {
        this.loading_administrator.push(false);
        this.search_administrator.push("");
        this.items_administrator.push([]);

        this.items_administrator[i].push(this.form.spracovatelia[i].user_full);
      }

      this.search_administrator.forEach((index, val) => {
        var unwatch = this.$watch(
          ["search_administrator", val].join("."),
          (newVal) => {
            this.querySelectionsAdministrator(newVal, val);
          }
        );
        this.watchers.push(unwatch);
      });
    },

    getItem() {
      this.loading = true;
      apiService.getInstitutionAdmin(this.$route.params.id).then((response) => {
        this.form = response;
        if (this.form.spracovatelia == null) {
          this.form.spracovatelia = [];
        }
        this.updateWatchersAnd();
        this.loading = false;
      });
    },

    updateItem() {
      apiService.updateInstitutionAdmin(this.form, this.$route.params.id).then(
        (response) => {
          this.snackbar_saved = true;
          this.form = response;
          this.updateWatchersAnd();
        },
        () => {
          this.snackbar_error = true;
        }
      );
    },

    addRow() {
      this.loading_administrator.push(false);
      this.search_administrator.push("");
      this.items_administrator.push([]);

      this.form.spracovatelia.push({
        user: "",
        institution: this.$route.params.id,
        type: "",
      });

      var index = this.search_administrator.length - 1;

      this.watchers.push(
        this.$watch(["search_administrator", index].join("."), (newVal) => {
          this.querySelectionsAdministrator(newVal, index);
        })
      );
    },

    deleteRowSpracovatel(index) {
      for (var i = 0; i < this.watchers.length; i++) {
        this.watchers[i]();
      }
      this.watchers = [];

      this.form.spracovatelia.splice(index, 1);
      this.loading_administrator.splice(index, 1);
      this.items_administrator.splice(index, 1);
      this.search_administrator.splice(index, 1);

      this.search_administrator.forEach((index, val) => {
        var unwatch = this.$watch(
          ["search_administrator", val].join("."),
          (newVal) => {
            this.querySelectionsAdministrator(newVal, val);
          }
        );

        this.watchers.push(unwatch);
      });
    },

    querySelectionsAdministrator(v, index) {

      this.loading_administrator[index] = true;

      apiService.searchUsers(v).then((response) => {
        this.items_administrator[index] = response.results;
        this.loading_administrator[index] = false;
      });
    },
  },
};
</script>